import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  connect() {
    // Close modal on escape key
    this.escapeHandler = this.handleEscape.bind(this);
    document.addEventListener("keydown", this.escapeHandler);

    this.boundCloseFromTurbo = this.closeFromTurbo.bind(this);
    document.addEventListener("modal:close", this.boundCloseFromTurbo);
  }

  disconnect() {
    document.removeEventListener("keydown", this.escapeHandler);
    document.removeEventListener("modal:close", this.boundCloseFromTurbo);
  }

  open(event) {
    event.preventDefault();
    this.modalTarget.classList.remove("hidden");
  }

  close(event) {
    if (event) {
      event.preventDefault();
    }
    this.modalTarget.classList.add("hidden");
  }

  closeOnOutsideClick(event) {
    // Close if clicking on the backdrop (not the modal content)
    if (event.target === this.modalTarget) {
      this.close(event);
    }
  }

  closeFromTurbo() {
    this.close();
  }

  handleEscape(event) {
    if (
      event.key === "Escape" &&
      !this.modalTarget.classList.contains("hidden")
    ) {
      this.close();
    }
  }
}
